import { useState } from "react";

const SignupForm = ({ onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Password: "",
    Address: "",
    City: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "500px" }}>
        <h3 className="text-center mb-3">Signup</h3>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="FirstName"
                className="form-control"
                placeholder="First Name"
                required
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="LastName"
                className="form-control"
                placeholder="Last Name"
                required
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="mb-3">
            <input
              type="email"
              name="Email"
              className="form-control"
              placeholder="Email"
              required
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              name="Password"
              className="form-control"
              placeholder="Password"
              required
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              name="Address"
              className="form-control"
              placeholder="Address"
              required
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <input
              type="text"
              name="City"
              className="form-control"
              placeholder="City"
              required
              onChange={handleChange}
            />
          </div>
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>
            {loading ? "Signing up..." : "Signup"}
          </button>
        </form>

        <div className="text-center mt-3">
          <p>
            Already have an account? <a href="/login">Sign In</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
